import { Component, OnInit } from '@angular/core';
import { MatToolbarModule } from '@angular/material/toolbar';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterLinkActive,
} from '@angular/router';
import { CommonModule } from '@angular/common';
import { HowToPlayService } from '../../../../shared/services/how-to-play.service';

@Component({
  selector: 'app-toolbar',
  standalone: true,
  imports: [MatToolbarModule, RouterLink, RouterLinkActive, CommonModule],
  templateUrl: './toolbar.component.html',
  styleUrl: './toolbar.component.scss',
})
export class ToolbarComponent implements OnInit {
  currentRoute = '';
  scenairoId = '';

  scenarioIdSessionStorage = sessionStorage.getItem('scenarioId');

  constructor(
    private router: Router,
    readonly route: ActivatedRoute,
    private howToPlayService: HowToPlayService
  ) {}

  ngOnInit(): void {
    console.log(this.scenarioIdSessionStorage);
    this.currentRoute = this.router.url;
    this.scenairoId = this.route.snapshot.paramMap.get('id')!;
  }

  openHowToPlayGuide(): void {
    this.howToPlayService.openHowToPlayGuide();
  }

  shouldShowHowToPlayButton(): boolean {
    return (
      this.currentRoute.includes('/prepare') ||
      this.currentRoute.includes('/decide')
    );
  }
}
